<template lang='pug'>
  .billboard-item(v-if='billboard && billboard.attributes')
    template(v-if='billboard.attributes.link')
      a.banner-image-link(:href='billboard.attributes.link' :data-image='billboard.attributes["image-url"]' :target='billboard.attributes["new-tab"] ? "_blank" : null')
        img.banner-image(:src='billboard.attributes["image-url"]' :alt='title')

    template(v-else)
      img.banner-image(:src='billboard.attributes["image-url"]' :alt='title')

    .media-container(v-if='billboard.attributes["banner-video-id"]')
      a.video-link.js-video-link(:href='`#billboard-video-${billboard.attributes["banner-video-id"]}`' data-toggle='modal' :data-video='billboard.attributes["banner-video-id"]')
        .video-image-overlay
        img.video-image(:src='videoThumbImage(billboard.attributes["banner-video-id"])' v-if='showVideoImage')
        span.video-play-icon
    a.terms-link(href='#billboard-terms' data-toggle='modal' v-text='$t("common.termsAndConditions")' v-if='billboard.attributes["terms-and-conditions"]')
    billboard-terms-and-conditions(
      v-if='billboard.attributes["terms-and-conditions"]'
      :image='billboard.attributes["terms-and-conditions"]["image-url"]'
      :description='billboard.attributes["terms-and-conditions"].description'
      :title='billboard.attributes["terms-and-conditions"].title'
    )

    template(v-if='billboard.attributes["main-banner"]')
      .brand-description(v-if='entity.attributes.description')
        .brand-name(v-text='entity.attributes.name')
        p.desc(v-text='entity.attributes.description')
</template>

<script>
import { mapState } from 'vuex'
import BillboardTermsAndConditions from './terms-and-conditions.vue'

export default {
  components: {
    BillboardTermsAndConditions
  },

  props: [
    'billboard',
    'title',
    'showVideoImage'
  ],

  computed: {
    ...mapState({
      entity: state => state.product.entity
    })
  },

  methods: {
    videoThumbImage (videoId) {
      return `//img.youtube.com/vi/${videoId}/sddefault.jpg`
    }
  }
}
</script>

<style scoped lang='scss'>
  .banner-image {
    width: 100%;
  }

  .media-container {
    display: none;
    position: absolute;

    @include media-breakpoint-up(sm) {
      display: block;
      right: 30px;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 290px;
      height: 160px;
    }

    @include media-breakpoint-up(lg) {
      width: 360px;
      height: 200px;
    }

    @include media-breakpoint-up(xl) {
      right: 40px;
      width: 400px;
      height: 225px;
    }

    .video-link {
      overflow: hidden;
    }

    .video-image {
      width: 100%;
      margin-top: -9.5%;
    }
  }

  .terms-link {
    height: 25px;
    width: 120px;
    transition: all 0.3s ease 0s;
    cursor: pointer;
    text-decoration: underline;
    font-size: 11px;
    line-height: 25px;
    text-align: center;
    display: block;

    &:hover {
      background: $grey-dark;
      color: $white;
    }
  }

  .brand-description {
    @include media-breakpoint-up(sm) {
      padding: 10px 20px;
      margin: auto;
      border: 0;
      background-color: $white;
      line-height: 16px;
      font-size: 14px;
      width: 60%;
      height: 150px;
      opacity: 0.95;
      overflow: hidden;
      position: absolute;
      right: 30px;
      top: 0;
      bottom: 0;
    }

    @include media-breakpoint-up(lg) {
      width: 400px;
      height: 200px;
      padding: 25px 20px 10px;
    }

    @include media-breakpoint-up(xl) {
      right: 40px;
    }

    .brand-name {
      @include font-weight-bold;
      text-transform: uppercase;
      margin-bottom: 10px;

      @include media-breakpoint-up(sm) {
        margin: 7px 14px;
      }
    }

    .desc {
      @include font-weight-book;

      @include media-breakpoint-up(sm) {
        font-size: 13px;
        line-height: 16px;
        margin: 0 14px;
      }
    }
  }
</style>
